import AccountsForm from '../../../components/People/Accounts/AccountsForm'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import React, {Component, Fragment} from 'react'
import {compose} from 'recompose'

class Accounts extends Component {
  render() {
    return (
      <Fragment>
        <AccountsForm
          loading={this.props.fetchingClient}
          {...this.props}
          ref={this.props.userRef}
        />
      </Fragment>
    )
  }
}

export default compose(withLoadingSection)(Accounts)
